export default __webpack_public_path__ + "static/media/plurato-sailfin-efoil-1.99391ec4.jpg";